<div class="max-w-3xl mx-auto p-6 bg-white rounded-xl shadow-md space-y-8">
  <section>
    <h2 class="text-2xl font-semibold text-gray-800 border-b pb-2 mb-4">Google Merchant Feed</h2>

    <p class="text-sm text-gray-600 mb-4">
      Products in the category selected below (and in its subcategories) are tagged with
      <code>custom_label_0 = offers</code> in the product feed, so they can be grouped as offers on Google Merchant.
      The label is added and removed automatically as products move in and out of the category.
    </p>

    <div class="space-y-4">
      <cac-field [control]="form.controls.offersCategoryId" label="Offers category" controlType="select"
        [items]="categoryItems$" [searchable]="true" placeholder="Select the offers category">
      </cac-field>

      @if (isDefault) {
      <p class="text-sm text-amber-600">
        No offers category has been saved yet; the built-in default category is in use.
      </p>
      }
    </div>
  </section>

  <section class="border-t pt-6">
    <h3 class="text-lg font-semibold text-gray-800 mb-2">Regenerate now</h3>

    <p class="text-sm text-gray-600 mb-4">
      The feed is rebuilt automatically every night. Use this button to publish the current catalog immediately,
      for example right after changing the offers category or the discounted prices.
    </p>

    <cac-button (onClick)="regenerate($event)" [disabled]="isRegenerating()" icon="refresh">
      {{ isRegenerating() ? 'Regenerating…' : 'Regenerate feed now' }}
    </cac-button>
  </section>

  <div class="flex justify-end">
    <cac-button (onClick)="save($event)" [disabled]="!isFormValid()">Save</cac-button>
  </div>
</div>
